import { render, staticRenderFns } from "./BaseZipcode.vue?vue&type=template&id=f213704e&"
import script from "./BaseZipcode.vue?vue&type=script&lang=js&"
export * from "./BaseZipcode.vue?vue&type=script&lang=js&"
import style0 from "./BaseZipcode.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports